export class NotImplementedException extends Error {
  constructor() {
    super('Not yet implemented');
  }
}
